import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ActivePageTracking {
  activePageName: string
}

interface ActivePageState {
  value: ActivePageTracking
}

const initialState: ActivePageState = { value: { activePageName: '' } }

const activePageSlice = createSlice({
  name: 'activepage',
  initialState,
  reducers: {
    updateActivePage(
      state,
      action: PayloadAction<{
        activePageName: string
      }>
    ) {
      state.value = {
        ...state.value,
        ...action.payload,
      }
    },
  },
})

export const { updateActivePage } = activePageSlice.actions
export default activePageSlice.reducer
